// @flow
import React, { Component } from "react";

import UserAuth from "../../global/containers/UserAuth";
import RedirectoLogin from "../views/RedirectoLogin";
import MySoftwares from "../containers/softwares/MySoftwares";

class Project extends Component<*> {
  render(): * {
    return (
      <UserAuth
        oneOfPrincipalList={[
          "company_children_write",
          "company_children_read",
          "imagus_admin"
        ]}
        unAuthChildren={<RedirectoLogin />}
      >
        <div className="app-main">
          <MySoftwares />
        </div>
      </UserAuth>
    );
  }
}

export default Project;
